<template>
  <span>
    <span v-if="isNew" class="round-box-danger">Uusi</span>

    <span v-if="isCheckingAvailability" class="round-box-warning">Selvitetään saatavuutta</span>

    <span v-if="isWaiting" class="round-box-success">Odotetaan kuvailukappaletta</span>

    <span v-if="isProcessing" class="round-box-info">Käsittelyssä</span>

    <span v-if="isReady" class="round-box-light-green">Valmis</span>
  </span>
</template>

<script>


export default {
  props: {
    query: Object,
  },

  computed: {
    isNew() {
      return this.query.status == 'new'
    },

    isCheckingAvailability() {
      return this.query.status == 'checking_availability'
    },

    isWaiting() {
      return this.query.status == 'waiting'
    },

    isProcessing() {
      return ['processing', 'in_virtual_list'].includes(this.query.status)
    },

    isReady() {
      return this.query.status == 'ready'
    },
    
  },
  
}

</script>
